exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa5[data-v-67f5d75f] {\n  width: 18px !important;\n}\n.dropdown-notifications .dropdown-item[data-v-67f5d75f] {\n  padding: 4px 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  white-space: nowrap; \n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dropdown-notifications .dropdown-item[data-v-67f5d75f]:last-child {\n  border-bottom: 0px;\n}\n.dropdown-notifications .dropdown-item small[data-v-67f5d75f] {\n  width: 100%;\n  display: block;\n  color: #ababab;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67f5d75f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/Dashboard/Layout/TopNavbar.vue
// module id = o6Hc
// module chunks = 4